import { ErrorHandler, Provider } from "@angular/core";
import { ApplicationinsightsAngularpluginErrorService } from "@microsoft/applicationinsights-angularplugin-js";
import { isCookieAccepted, isCookiePerformanceAccepted } from "./global";

export const CookiesConsentProviders: Provider[] =
  isCookieAccepted() && isCookiePerformanceAccepted()
    ? [
        {
          provide: ErrorHandler,
          useClass: ApplicationinsightsAngularpluginErrorService,
        },
      ]
    : [];
